import Request from '../../../../services/request/request';
import TokenManager from '../../../../services/TokenManager';

export const MFA_SMS = 'SMS';
export const MFA_SOFTWARE = 'SOFTWARE';
export const VALID_MFA_METHODS = [MFA_SMS, MFA_SOFTWARE];


const Commands = {
    /**
     * Set the users phone number for SMS TFA
     *
     * @param String number - +447825600704 (must be in this format)
     * 
     * @return Promise
     */
    setPhoneNumber(number) {
        return Request.post('/auth/phone-number/update', {
            PhoneNumber: number,
        }, {
            Authorization: 'Bearer ' + TokenManager.fromLocalStorage().AccessToken
        }).catch((err) => {
            if (err.Error) {
                throw new Error(err.Error);
            }
        });
    },

    configureMfa() {
        return Request.post('/auth/software-mfa/configure', {}, {
            Authorization: 'Bearer ' + TokenManager.fromLocalStorage().AccessToken,
        }).catch((err) => {
            if (err.Error) {
                throw new Error(err.Error);
            }
        });
    },

    confirmMfa(code, name = '') {
        return Request.post('/auth/software-mfa/confirm', {
            MfaCode: code,
            FriendlyName: name,
        }, {
            Authorization: 'Bearer ' + TokenManager.fromLocalStorage().AccessToken,
        }).catch((err) => {
            if (err.Error) {
                throw new Error(err.Error);
            }
        });
    },

    mfaPreferences(sms, software, preferred = null) {
        if (preferred && !VALID_MFA_METHODS.includes(preferred)) {
            return Promise.reject(new Error('Prefered MFA method not supported'));
        }

        return Request.post('/auth/mfa-preferences', {
            SMS: sms,
            Software: software,
            Preferred: preferred,
        }, {
            Authorization: 'Bearer ' + TokenManager.fromLocalStorage().AccessToken,
        }).catch((err) => {
            if (err.Error) {
                throw new Error(err.Error);
            }
        });
    }
}

export default Commands;
